import { Box, Stack, Text } from '@chakra-ui/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Colors from '../../config/colors';
import { useTranslation } from 'react-i18next';
import PaymentListItem from './components/PaymentListItem';
import { IPaymentItem, PAYMENT_LIST } from '../../config/payments';

interface Props {
    payments: IPaymentItem[]
    currentPayment: string;
    setCurrentPayment: (payment: string) => void;
}

export default function PaymentList({ payments, currentPayment, setCurrentPayment}: Props) {
    const [t, i18next] = useTranslation();

    return (
        <Box display="flex" flexDirection="column" gap="2" fontWeight="300">
            <Text fontSize="16px" color="#fff">
                {t('select-payment-method')}
            </Text>
            <Stack direction={['column']} spacing={4}>
                {payments.map((item) => (
                    <PaymentListItem
                        title={item.title}
                        name={item.name}
                        description={t(item.localeDesciption)}
                        imgURL={item.imgURL}
                        setCurrentPayment={setCurrentPayment}
                        isActive={currentPayment === item.name}
                    />
                ))}
            </Stack>
        </Box>
    );
}
